import React, {useState, useEffect} from 'react';
import {useRouter} from 'next/router';
import GalleryService from '@services/gallery-web.service';
import {getLocaleContent} from '@helper/locale-content.js';
import LoadingNavigation from '@components/common/Loading/LoadingNavigation';

export default function InfrastructureCarousel({medicalFacility, department}) {
    const {locale} = useRouter();
    const [index, setIndex] = useState(0);
    const [gallerys, setGallery] = useState([]);
    const [mainImage, setMainImage] = useState('');
    const [loading, setLoading] = useState(true);

    const loadGallery = async () => {
        const galleryService = new GalleryService();
        let res;

        // Reset state trước khi load data mới
        setGallery([]);
        setMainImage('');
        setIndex(0);

        // Nếu có department, lấy gallery theo department
        if (department) {
            const dept = Array.isArray(department) ? department[0] : department;

            if (!dept?.department_id) {
                setLoading(false);
                return;
            }

            res = await galleryService.getGalleryByDepartment({
                department_id: dept.department_id,
                locale: locale,
            });
        } else if (medicalFacility) {
            // Xử lý trường hợp medicalFacility có thể là array hoặc object
            const facility = Array.isArray(medicalFacility) ? medicalFacility[0] : medicalFacility;

            // Kiểm tra business_id có tồn tại không
            if (!facility?.business_id) {
                setLoading(false);
                return;
            }

            res = await galleryService.getGalleryByBusiness({
                business_id: facility.business_id,
                locale: locale,
            });
        } else {
            // Lấy gallery chung với tag 'aboutus'
            res = await galleryService.getListGalleryTags({
                keyword: 'aboutus',
                is_active: 1,
                locale: locale,
            });
            res = res.items || [];
        }

        // Xử lý response có thể là array trực tiếp hoặc có property data
        let data = [];
        if (Array.isArray(res)) {
            data = res;
        } else if (res?.data && Array.isArray(res.data)) {
            data = res.data;
        }
        data = data.sort((a, b) => a.order_index - b.order_index);
        // Luôn set gallery, kể cả khi empty
        if (data.length) {
            setGallery(data);
            setMainImage(data[0].image_url);
        } else {
            setGallery([]);
            setMainImage('');
        }

        setLoading(false);
    };

    useEffect(() => {
        // Reset loading state khi department/medicalFacility thay đổi
        setLoading(true);
        loadGallery();
    }, [department?.department_id, medicalFacility?.business_id, locale]);

    // Cleanup function để reset state khi component unmount
    useEffect(() => {
        return () => {
            setGallery([]);
            setMainImage('');
            setIndex(0);
        };
    }, []);

    if (loading) return <LoadingNavigation size="large" color="#006940" style={{padding: '50px'}} />;
    if (!gallerys.length) return null;

    const item = gallerys[index];

    console.log(item);

    const handlePrev = () => {
        const newIndex = index === 0 ? gallerys.length - 1 : index - 1;
        setIndex(newIndex);
        setMainImage(gallerys[newIndex].image_url);
        console.log(gallerys[newIndex]);
    };

    const handleNext = () => {
        const newIndex = index === gallerys.length - 1 ? 0 : index + 1;
        setIndex(newIndex);
        setMainImage(gallerys[newIndex].image_url);
    };

    const handleThumbClick = newIndex => {
        setIndex(newIndex);
        setMainImage(gallerys[newIndex].image_url);
    };

    return (
        <div className="infrastructure-bg">
            <section className="infrastructure">
                <div className="section-content">
                    <div className="infrastructure-header">
                        <h2>
                            {getLocaleContent(locale, 'page.medical-facility.infrastructure-title')}{' '}
                            <span>{getLocaleContent(locale, 'page.medical-facility.infrastructure-subtitle')}</span>
                        </h2>
                    </div>

                    <div className="infrastructure-info-area">
                        <div className="infrastructure-content">
                            <div className="infrastructure-image">
                                <img src={mainImage} alt={item?.image_name || ''} />
                            </div>
                        </div>

                        <div className="infrastructure-info">
                            <div className="infrastructure-info-bg">
                                <h3>
                                    {locale === 'vn' ? item?.image_name : item?.image_name_en ?? item?.image_name ?? ''}
                                </h3>
                                <p>{item?.description || ''}</p>
                            </div>
                        </div>

                        {gallerys.length > 1 && (
                            <div className="infrastructure-controls">
                                <button onClick={handlePrev}>←</button>
                                <button onClick={handleNext}>→</button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="infrastructure-thumbnails">
                    {gallerys.map((g, i) => (
                        <div key={g.image_id || i} className="thumb">
                            <img
                                src={g.image_url}
                                alt={g.image_name || `thumb-${i}`}
                                className={i === index ? 'active' : ''}
                            />
                            <div
                                onClick={() => handleThumbClick(i)}
                                className={i !== index ? 'overlay-deactive' : ''}></div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
